import { NoticeMessage as ErrorMessage } from 'components/Notice';
import { NOTICE_MESSAGES } from 'libs/constants';
import Raven from 'libs/Raven';
import languages from 'i18n';
import { IntlProvider } from 'react-intl';
import getStore from 'libs/store';

function getIntl(locale) {
  const intlProvider = new IntlProvider({ locale, messages: languages[locale] });
  const { intl } = intlProvider.getChildContext();
  return intl;
}

function isApiError(error = {}) {
  if (!Object.keys(error).length || !error.hasOwnProperty('response')) {
    return false;
  } else if (
    error.response &&
    error.response.status !== 500 &&
    error.response.body &&
    error.response.body.message || error.response.body.detail
  ) {
    return true;
  }
  return false;
}

export function logApiError(error = {}) {
  if (
    isApiError(error)
  ) {
    const capturedError = new Error(error.response.body.message || error.response.body.detail);
    Raven.captureException(capturedError);
  }
}

export function formatErrorMessage(error = {}) {
  const { i18n: { info: { locale } } } = getStore().getState();
  const intl = getIntl(locale);
  let errorMessage = false;
  if (
    isApiError(error)
  ) {
    const { showContact, message, detail } = error.response.body;

    errorMessage = ErrorMessage(
      {
        text: message || detail,
        optionalText: showContact && intl.formatMessage({ id: NOTICE_MESSAGES.showContact })
      }
    );
  } else {
    errorMessage = `${intl.formatMessage({ id: NOTICE_MESSAGES.general })} ${intl.formatMessage({ id: NOTICE_MESSAGES.showContact })}`;
  }
  return errorMessage;
}

export function formatMessage(messageKey) {
  const { i18n: { info: { locale } } } = getStore().getState();
  const intl = getIntl(locale);

  return intl.formatMessage({ id: messageKey });
}

export default {
  formatErrorMessage
};



// WEBPACK FOOTER //
// ./src/libs/notice.js